<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 45 45">
		<g transform="translate(-1085 -329)">
			<path
				d="M3,29.721v7.031h7.031L30.769,16.015,23.737,8.983ZM36.206,10.577a1.867,1.867,0,0,0,0-2.644L31.819,3.546a1.867,1.867,0,0,0-2.644,0L25.744,6.977l7.031,7.031Z"
				transform="translate(1087.625 331.623)"
			/>
			<path class="a" d="M0,0H45V45H0Z" transform="translate(1085 329)" />
		</g>
	</svg>
</template>

<script>
export default {
	name: 'b-icon-create',
	components: {},
	computed: {},
	props: {}
};
</script>

<style scoped lang="scss">
.a {
	fill: none;
}
</style>

<docs>
    IconCreate

    ```js
    <b-icon-create />
    ```
</docs>
